import * as lib from '~/dependencies';
import { measures } from '~/layout';

export const LogoStyled = lib.styled.div`
  .logo {
    width: ${measures.authScreen.logoLogin.width}px;
    height: ${measures.authScreen.logoLogin.height}px;
  }
`;
